import { fetchSearch } from '@/components/search/_helpers/fetchData';
import Search from '@/components/search/Search';
import { getUserAgent } from '@/helpers/userAgent';
import { checkIsWhiteLabel } from '@/helpers/checkEnvironments';
const SearchPage = ({
  data,
  isBot,
  host
}) => {
  return <Search firstData={data} isBot={isBot} host={host} data-sentry-element="Search" data-sentry-component="SearchPage" data-sentry-source-file="[[...routes]].tsx" />;
};
export default SearchPage;
export const getServerSideProps = async ctx => {
  // FOR LONG TERM
  // const isWhiteLabel = checkIsWhiteLabel()
  const isMidterm = ctx.query?.mid_term;
  if (isMidterm) {
    const [pathname, queryString] = ctx.resolvedUrl.split('?');
    const params = new URLSearchParams(queryString);
    params.delete('mid_term');
    const newUrl = params.toString() ? `${pathname}?${params.toString()}` : pathname;
    return {
      redirect: {
        destination: newUrl,
        permanent: false
      }
    };
  }
  const ua = getUserAgent(ctx.req);
  const host = 'https://' + ctx.req.headers.host;
  const allowedRouteOne = ['city', 'province', 'tags', 'village'];
  const routes = ctx?.query?.routes;
  const rashtCity = 'رشت';
  const nearCitiesRaw = ctx.query?.near_cities;
  const nearCity = Array.isArray(nearCitiesRaw) ? nearCitiesRaw.length === 1 ? nearCitiesRaw[0] : undefined : nearCitiesRaw;
  if ((!routes || routes.length === 0) && String(nearCity) === rashtCity) {
    const [, queryString] = ctx.resolvedUrl.split('?');
    const params = new URLSearchParams(queryString);
    params.delete('near_cities');
    const destination = params.toString() ? `/search/city/${encodeURIComponent(rashtCity)}?${params.toString()}` : `/search/city/${encodeURIComponent(rashtCity)}`;
    return {
      redirect: {
        destination,
        permanent: true
      }
    };
  }
  if (routes?.length === 2) {
    const [firstRoute, secondRoute] = routes;
    if (!allowedRouteOne.includes(firstRoute as string) || allowedRouteOne.includes(secondRoute as string)) {
      return {
        notFound: true
      };
    }
  } else if (routes?.length > 2 || routes?.length === 1) {
    return {
      notFound: true
    };
  }
  if (process.env.OFFLINE_MODE === 'true') {
    const {
      offlineSearchProps
    } = await import('@/helpers/offline/snapshot');
    return offlineSearchProps(ctx, ua);
  }
  const referralApp = ctx.req.cookies?.referral_app;
  const extraApiParams = referralApp === 'special' ? {
    high_or_zero_accept_rate: 0.6
  } : {};
  const data = await fetchSearch(ctx.query, ctx.req, 24, extraApiParams);
  return {
    props: {
      data,
      isBot: true,
      host,
      ua
    }
  };
};